import React from "react";

function WomenCom() {
  return (
    <div className="row row-cols-1 row-cols-md-2 justify-content-center align-items-center">
      <div className="col">
        <h2 className="text-h-m-orange">Gendered Jailing</h2>
        <br />
        <h2 className="text-h-black">“A Choice of Evils” to Protect Women</h2>
        <br />
        <br />
        <p>
          The jailing of women has presented a vexing problem that persists
          until today: what is to be done with women who are seen as defying
          societal gender norms, whether members of the working class who become
          drug smugglers or political prisoners involved in protests and
          rioting? For the latter, Thapar-Bjorkert explains that the colonial
          administration was unsure of what to do with women agitators as they
          were the ‘weaker,’ ‘fairer’ sex, and was reluctant to arrest them, but
          fearful that such hesitation would enable further empowerment of their
          movement. For the former group, Sen’s examination of prison documents
          uncovers an anxious preoccupation among reform administrators to
          ensure the complete segregation of men and women in jail, as the
          pivotal solution.
        </p>
      </div>
      <div className="col">
        <img
          style={{ width: "100%", height: "100%" }}
          src={require("../../assets/images/women-dotted-2.png")}
          alt="women-dotted-2"
        />
      </div>
    </div>
  );
}

export default WomenCom;
